import React from 'react';

import { ConnectedSpaceInfoProvider } from '~src/spacesPlatform/components/Explorer/helpers/SpaceInfoProvider';
import { NavLocationAreas } from '~src/spacesPlatform/components/layout/NavLocation';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';

import { ContentRelayPlanDetailsSpaceContainer } from './ContentRelayPlanDetailsSpaceContainer';

export interface ContentRelayPlanDetailsSpaceProviderProps {
  /** LUID of the plan being shown, parsed from the route. */
  readonly planLuid: string;
  readonly urls: SpacesSiteUrls;
}

const ContentRelayPlanDetailsSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'contentRelayPlanDetails',
  subspaceName: 'overview',
  // Keep "Content Relays" highlighted in the side nav while on a plan.
  navLocationOverride: NavLocationAreas.SiteContent.content_relay,
};

/**
 * Provider for the Content Relay plan detail page (#/contentRelayPlans/:luid). Sets the space info,
 * then renders the container that loads the plan and owns page state.
 */
export const ContentRelayPlanDetailsSpaceProvider: React.FunctionComponent<ContentRelayPlanDetailsSpaceProviderProps> = props => {
  return (
    <ConnectedSpaceInfoProvider spaceInfo={ContentRelayPlanDetailsSpaceInfo}>
      <ContentRelayPlanDetailsSpaceContainer planLuid={props.planLuid} urls={props.urls} />
    </ConnectedSpaceInfoProvider>
  );
};
